<div *ngIf="!isMinimized" class="ac-debug-window-container">
	<div class="text-12 padding-10">Modify the config object and click "apply" to see the impact of changes.</div>
	<button class="ac-debug-window-minimize-icon" (click)="isMinimized = !isMinimized">-</button>
	<div class="text-12 ac-debug-window-option-container">
		<div *ngIf="currentConfig">
			<json-editor [options]="editorOptions" [data]="currentConfig" (jsonChange)="getChangedConfigObject($event)"></json-editor>
		</div>
	</div>
	<div class="padding-10">
		<button dz-button (click)="apply()">Apply</button>
		<button dz-button color="secondary" (click)="reset()">Reset</button>
	</div>
</div>

<button *ngIf="isMinimized" class="ac-debug-window-container-minimized" (click)="isMinimized = !isMinimized">
	<icon type="cog"></icon>
</button>
